import List from "@mui/material/List";
import Button from "@mui/material/Button";
import FormHelperText from "@mui/material/FormHelperText";
import { useFormContext } from "react-hook-form";
import { useDispatch } from "react-redux";
import { motion } from "framer-motion";
import { setPayment } from "store/vino/checkoutSlice";
import PaymentListItem from "./PaymentListItem";

const PaymentList = ({ paymentList }) => {
	const dispatch = useDispatch();

	const {
		setValue,
		formState: { errors },
	} = useFormContext();
	const container = {
		show: {
			transition: {
				staggerChildren: 0.1,
			},
		},
	};

	const item = {
		hidden: { opacity: 0, y: 20 },
		show: { opacity: 1, y: 0 },
	};

	if (paymentList.length === 0) {
		return null;
	}

	const handleAddNewCard = () => {
		setValue("addNewCard", true);
		setValue("selectPaymentMethod", false);
		setValue("paymentMethodId", "");
		dispatch(setPayment({}));
	};

	return (
		<div className="flex flex-col w-full">
			<div className="flex justify-end">
				<Button variant="contained" onClick={handleAddNewCard}>
					Add New
				</Button>
			</div>
			<List className="p-0">
				<motion.div variants={container} initial="hidden" animate="show">
					{paymentList.map((payment, index) => (
						<motion.div
							variants={item}
							key={index}
							className="flex flex-col py-5"
						>
							<PaymentListItem payment={payment} />
						</motion.div>
					))}
				</motion.div>
			</List>

			{errors.paymentMethodId && (
				<FormHelperText error>{errors.paymentMethodId.message}</FormHelperText>
			)}
		</div>
	);
};

export default PaymentList;
